<div class="mensagem" (click)="clicouMensagem()">
  <div class="texto">
    <div [ngClass]="{'tituloLida':mensagem.situacao.id === 1, 'tituloNaoLida':mensagem.situacao.id === 2, 'tituloExcluida':mensagem.situacao.id === 3}">{{mensagem.titulo}}</div>
    <div [ngClass]="{'detalheLida':mensagem.situacao.id === 1, 'detalheNaoLida':mensagem.situacao.id === 2, 'detalheExcluida':mensagem.situacao.id === 3}">Data: {{mensagem.dataMensagem|StringDTOToDate|amDateFormat:'DD/MM/YYYY HH:mm:ss'}}</div>
  </div>
</div>
